import { render, staticRenderFns } from "./OneLogin.vue?vue&type=template&id=96f803a2"
import script from "./OneLogin.vue?vue&type=script&lang=js"
export * from "./OneLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports